import { render, staticRenderFns } from "./OpenaiChangeTone.vue?vue&type=template&id=169fbd8a"
import script from "./OpenaiChangeTone.vue?vue&type=script&lang=js"
export * from "./OpenaiChangeTone.vue?vue&type=script&lang=js"
import style0 from "./OpenaiChangeTone.vue?vue&type=style&index=0&id=169fbd8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports